import React from 'react'

// import classes from './SetupCompetencyScoreHeader.scss'
import { Grid } from '@material-ui/core'

import CardHeader from '../../../../UI/Card/Header/Header'
import Button from '../../../../UI/Button/Button'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { camelCase } from 'lodash'

const SetupCompetencyScoreHeader = ({ companyData, translate, buttonClicked }) => {
    let companyInfo = null
    if (companyData?.length !== 0) {
        companyInfo = (
            <Grid container alignItems={'center'} justify={'space-between'} spacing={2}>
                <Grid item><b>{translate(camelCase('Line Business'))}:</b> {companyData?.business_line}</Grid>
                <Grid item><b>{translate(camelCase('Company'))}:</b> {companyData?.company_name}</Grid>
                <Grid item container spacing={2} sm justify={'flex-end'}>
                    <Grid item>
                        <Button size={'small'} btnColor={'success'} clicked={buttonClicked}>
                            {translate('addGroup')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
    return <CardHeader title={companyInfo} disableTypography={true} />
}

export default withTranslate(SetupCompetencyScoreHeader)
